import { render, staticRenderFns } from "./AltTahsilatTuruList.vue?vue&type=template&id=1c10a186"
import script from "./AltTahsilatTuruList.vue?vue&type=script&lang=ts"
export * from "./AltTahsilatTuruList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports